import { render, staticRenderFns } from "./start-build.vue?vue&type=template&id=3c46c4a8&"
import script from "./start-build.vue?vue&type=script&lang=js&"
export * from "./start-build.vue?vue&type=script&lang=js&"
import style0 from "./start-build.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports